import DataExtractionReport from '../DataExtractionReport';
import BaseEventPayload from './BaseEventPayload';

export default class DataExtractionEventPayload extends BaseEventPayload {
  constructor(data = {}, parentEventLog) {
    super(DataExtractionEventPayload, data, parentEventLog);
    this.dataExtractionState = data.dataExtractionState;
    this.dataExtractionReport =
      data.dataExtractionReport &&
      new DataExtractionReport(data.dataExtractionReport);
  }
}
